import React, { useState, useEffect } from "react";
import { useGame } from "context/gameContext";

import SkeletonLoader from "components/skeletonLoader";

import { query, collection, where, onSnapshot } from "firebase/firestore";
import { useFirestore } from "reactfire";
import LeagueCard from "components/leagueCard";
import {
  IonButton,
  IonContent,
  IonItem,
  IonLabel,
  IonList,
  useIonRouter,
} from "@ionic/react";
import { useTranslation } from "react-i18next";

const Leagues = () => {
  const firestore = useFirestore();
  const [joinedLeagues, setJoinedLeagues] = useState([]);
  const router = useIonRouter();
  const [listIsLoading, setListIsLoading] = useState(false);
  const {
    state: { userGameData },
  } = useGame();
  const { t } = useTranslation();

  useEffect(() => {
    if (!userGameData?.id) {
      return;
    }

    setListIsLoading(true);
    const q = query(
      collection(firestore, "userTournaments"),
      where("visible", "==", true),
      where("users", "array-contains", userGameData.id)
    );

    const unsubscribe = onSnapshot(
      q,

      (post) => {
        if (post.empty) {
          setListIsLoading(false);
          return;
        }
        const data = post.docs
          .filter((item) => {
            if (!item?.data().visible) {
              return false;
            } else return true;
          })
          .sort(function (x, y) {
            return y.data().settled
              ? -1
              : x.data().settled
              ? 1
              : y.data().id - x.data().id;
          })
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

        setJoinedLeagues(data);
        setListIsLoading(false);
      },
      (error) => {
        console.log(error);
        setListIsLoading(false);
      }
    );
    return () => unsubscribe();
  }, [userGameData?.id]);

  return (
    <IonContent className="mainPage">
      {!userGameData || listIsLoading ? (
        <div className="max-w-screen-md mx-auto ">
          <SkeletonLoader
            type={"tournamentCard"}
            amount={3}
            variant={"large"}
          />
        </div>
      ) : joinedLeagues?.length > 0 ? (
        // <div className="max-w-screen-md mx-auto ">
        <IonList
          mode="ios"
          className="no-lines grid grid-cols-1 gap-3  customItem transparentList accordion pb-20 max-w-screen-md mx-auto pt-2"
        >
          {joinedLeagues.map((item, index) => (
            <IonItem
              key={index}
              className="ionInputNoInnerPadding ion-no-padding  rounded-md mx-2"
              lines="none"
            >
              <LeagueCard
                leagueData={item}
                userGameData={userGameData}
                key={item.id}
              />
            </IonItem>
          ))}
        </IonList>
      ) : (
        // </div>
        <div className="max-w-screen-md mx-auto h-full">
          <div
            style={{
              "--image-url": `url(https://firebasestorage.googleapis.com/v0/b/oles-test-project.appspot.com/o/common%2Fempty.png?alt=media&token=f7becd7d-1143-4f17-8610-84228a9f61f4)`,
            }}
            className="bg-[image:var(--image-url)] w-full h-full bg-no-repeat bg-center bg-cover flex bg-opacity-40 "
          >
            <div className="bg-gradient-to-b  from-white/80 to-white/80 pt-14 w-full h-full items-center justify-center flex flex-col">
              <div className="flex flex-col text-lg font-light bg-white/50 px-20 shadow-md rounded-md  text-center py-10 justify-center m-4 space-y-2 backdrop-blur-sm">
                <div className="pb-6 text-center">
                  {t("lobby.empty.joinedtitle")}
                </div>
                <IonButton
                  mode="ios"
                  fill="solid"
                  color="success"
                  onClick={(e) => {
                    e.preventDefault();
                    router.push("/tabs/explore", "forward", "push");
                  }}
                  className="m-0 h-10 customButtonNew"
                >
                  <IonLabel className="text-sm text-black">
                    {t("lobby.empty.exploretournaments")}
                  </IonLabel>
                </IonButton>
              </div>
            </div>
          </div>
        </div>
      )}
    </IonContent>
  );
};

export default Leagues;
